import axios from "axios";

// Allow overriding backend URL at build-time via REACT_APP_API_BASE_URL
// If not provided, keep the existing fallback list
const envBase = process.env.REACT_APP_API_BASE_URL;
const BASE_URLS = envBase && envBase.trim().length > 0
  ? [envBase]
  : [
      //"http://192.168.1.178:5002",
      "https://localizacionback.ladero.com.py",
      "http://192.168.1.95:5002",     // IP principal
      //"http://181.94.246.105:5002",   // IP secundaria
      //"http://localhost:5002"         // fallback local
    ];

const createClient = (baseURL) => {
  const client = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  client.interceptors.request.use((config) => {
    const token = localStorage.getItem("sapToken");
    const user = JSON.parse(localStorage.getItem("sapUser"));

    if (user && user.ExpiresAt) {
      const expiresAt = new Date(user.ExpiresAt);
      const now = new Date();

      if (now >= expiresAt) {
        console.warn("⏰ Sesión de SAP expirada. Cerrando sesión y redirigiendo...");
        localStorage.removeItem("sapToken");
        localStorage.removeItem("sapUser");
        const base = process.env.PUBLIC_URL || "";
        window.location.href = `${base}/login`;
        return Promise.reject("Sesión expirada");
      }
    }

    if (token) {
      config.headers["Authorization"] = token;
    }

    return config;
  });

  return client;
};

const apiClient = {};

// Métodos tradicionales: get, post, put, patch, delete
["get", "post", "put", "patch", "delete"].forEach((method) => {
  apiClient[method] = async (url, dataOrConfig = {}, config = {}) => {
    let lastError;

    // Si es GET o DELETE, el segundo parámetro es `config`
    const isBodyless = method === "get" || method === "delete";

    for (const baseURL of BASE_URLS) {
      const client = createClient(baseURL);
      try {
        const response = await client.request({
          method,
          url,
          ...(isBodyless ? { ...dataOrConfig } : { data: dataOrConfig, ...config }),
        });
        return response;
      } catch (error) {
        lastError = error;
        console.warn(`❌ Error al intentar ${method.toUpperCase()} ${baseURL}${url}:`, error.message);
      }
    }

    throw lastError;
  };
});

export default apiClient;
